"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledChartContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledChartContainer = styled_components_1.default.div `
  margin: 0 auto 20px;
  max-width: 360px;
  width: 100%;
`;
